import { graphql, useStaticQuery } from "gatsby";

export const useFeaturedArticle = (articlesCategories?: string[]) => {
  const { articles } = useStaticQuery(graphql`
    query {
      articles: allSanityArticle(
        filter: {
          attributes: { publishedAt: { ne: null } }
          categories: { elemMatch: { title: { ne: null } } }
        }
        sort: { attributes: { publishedAt: DESC } }
      ) {
        edges {
          node {
            ...GatsbyArticleListingFragment
          }
        }
      }
    }
  `);

  const featuredArticles = articles?.edges?.filter(({ node }) => {
    const isCategoryPresent = node?.categories?.filter((category) =>
      articlesCategories?.includes(category?.title),
    );

    if (isCategoryPresent?.length) {
      return node;
    }
  });

  return {
    featuredArticles,
  };
};
